// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n+oYF","tab":"Switch_tab__gqhhe","currentTab":"Switch_currentTab__Ooa-P","fill":"Switch_fill__P0V75"};